import axios from '../index'

export default {
    
    getInstitucion (params) {
        return axios.get('/instituciones/usuario/', {
            params
        })
    },
    getCicloDefault (params = {}) {
        return axios.get('/api/v1/ciclos-escolares/directiva',{params})
    },
    getEstatusAlumno(params){
        return axios.get('/api/status',{params})
    },
    getInformacionAlumno(params){
        return axios.get('/api/v1/landing/getDatosAcademicos', {params})
    },
    getInfoGeneral(id_persona, params){
        return axios.get('/panel/alumno/get/' + id_persona, {params})
    },
    getInfoAlumnoSeguimientoGeneral(id_persona, institucion){
        return axios.get('/panel/seguimiento/get/' + id_persona + '/' + institucion)
    },
    getCiudades (estado) {
        return axios.get('/ciudades/estado/' + estado)
    },
    postPerfil(personaId, payload){
        return axios.post('/panel/actualizar/' + personaId, payload)
    },
    postDatosMedicos(personaId, payload){
        return axios.post('/panel/actualizarDatosMedicos/' + personaId, payload)
    },
    postDatosReferenciales(personaId, payload){
        return axios.post('/panel/actualizarDatosReferenciales/' + personaId, payload)
    },
    postChangeAvatar(personaId, formData){
        return axios.post('/api/personas/' + personaId + '/avatar', formData)
    },

    // HERMANOS MENU 
    getHermanosAlumno(params){
        return axios.get('/api/v1/landing/getHermanosConPrograma', {params})
    },

    // FAMILIARES 
    postVincularFamiliar(payload){
        return axios.post('/panel/crearFamiliar', payload)
    },
    postEstablecerTutor(payload){
        return axios.post('/panel/establecerTutor', payload)
    },
    comprobarVinculacionesExternas(idFamiliar){
        return axios.get('/panel/desvincularFamiliar/' + idFamiliar)
    },
    postDesvincularFamiliar(payload){
        return axios.post('/panel/quitarVinculo', payload)
    },
    postEditarFamiliar(payload){
        return axios.post('/panel/editarFamiliar', payload)
    },
    getHermanosVinculados(personaId){
        return axios.get('/panel/hermanos/' + personaId)
    },
    gethijosConPrograma(params){
        return axios.get('/api/v1/landing/getHijosConPrograma', {params})
    },
    postVincularHermano(personaId,ids_hermanos){
        return axios.post('/panel/vincular/hermano/' + personaId, ids_hermanos)
    },

    // DATOS FISCALES 
    
    getRegimen(){
        return axios.get('/api/v1/sat/regimenes')
    },
    postDatosFiscales(personaId, payload){
        return axios.post('/panel/actualizarDatosFiscales/' + personaId , payload)
    },
    postEliminarDatosFiscales(personaId){
        return axios.post('/panel/eliminar-datos-fiscales/' + personaId)
    },

    // BAJAS Y SUSPENCIONES 
    getEstatusBajasSuspenciones(personaId, params){
        return axios.get('/panel/estatus/' + personaId, {params} )
    },
    postBajasSuspenciones(personaId, formData){
        return axios.post('/panel/alumno/' + personaId + '/estatus', formData)
    },

    // BECAS 
    getCicloEscolares(institucionId){
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/' + institucionId)
    },
    getBecas(personaId, institucionId, cicloEscolarId){
        return axios.get('/panel/alumno/' + personaId + '/becas-disponibles/' + institucionId + '/' + cicloEscolarId)
    },
    getBecasAsignadas(personaId, institucionId, cicloEscolarId){
        return axios.get('/panel/alumno/' + personaId + '/becas-asignadas/' + institucionId + '/' + cicloEscolarId)
    },
    postEditarBeca(becaId, formData){
        return axios.post('/panel/alumno/becas/' + becaId, formData)
    },
    postAsignarBecas(personaId, formData){
        return axios.post('/panel/alumno/' + personaId + '/becas', formData)
    },

    // GESTIÓN DE ACCESOS 
    getSesionesUsuario(id_user){
        return axios.get('/panel/user/sesiones/' + id_user)
    },
    getAccesoAlumno(personaId, params){
        return axios.get('/panel/usuario/crear-accesos/' + personaId, {params})
    },
    getAccesosFamiliares(personaId, params){
        return axios.get('/panel/usuario/crear-accesos/' + personaId, {params})
    },
    getRecuperarPassword(user){
        return axios.get('/panel/usuario/reset-password/' + user)
    },
    postEditarAccesos(user, formData){
        return axios.post('/panel/alumno/' + user + '/accesos', formData)
    },
    getEliminarAcceso(id_familiar, id_persona){
        return axios.get('/panel/usuario/desvincularUser/' + id_familiar + '/' + id_persona)
    },

    // PROCESO DE ADMISIOÓN
    getInformacionProcesoAdmision(idPersona, lastUrl){
        return axios.get('/panel/seguimiento/get/' + idPersona + '/' + lastUrl)
    },
    publicarComentario(payload, id){
        return axios.post('/panel/comentar/' + id, payload)
    },
    postEnviarCorreoProceso(payload){
        return axios.post('/panel/enviarCorreo', payload)
    },
    postCongelar(id){
        return axios.post('/panel/congelar/' + id)
    },
    postReactivar(status, id){
        return axios.post('/panel/reactivar/' + status + '/' + id)
    },
    postDescartar(id){
        return axios.post('/panel/descartar/' + id)
    },
    postAvanzar(id, formData){
        return axios.post('/panel/avanzar/' + id, formData)
    },
    postAvanzarCurp(id, formData){
        return axios.post('/panel/avanzar/' + id, formData)
    },
    postRetroceder(id){
        return axios.post('/panel/retroceder/' + id)
    },

    // HISTORICO CORREO 
    getHistoricoCorreo(params){
        return axios.get('/api/v1/landing/getCorreosInstitucionales', {params})
    },
    getEditarCorreoHistorico(params){
        return axios.post('/api/v1/landing/correoInstitucionalStore', params)
    },

    // INTENCIÓN DE PAGO
    postDescargarFicha(formData){
        return axios.post('/cobranza/descargar-ficha-de-pago', formData)
    },
    postDescargarFichaSantander(formData){
        return axios.post('/cobranza/descargar-ficha-de-pago-santander', formData)
    },
    postEnviarFicha(formData){
        return axios.post('/cobranza/enviarEmail', formData)
    },
    postEnviarFichaSantander(formData){
        return axios.post('/cobranza/enviarEmailSantander', formData)
    }

}